export enum Region {
  US = 'US',
  CA = 'CA'
}
